import {z} from "zod";
import {ManagerInformationModel} from "../../tax-corporation";
import {HalfYearModel} from "./HalfYearModel";

const schema = z.object({
	department: z.string(),
	managerInformation: ManagerInformationModel.model.nullable(),
	halfYears: z.array(HalfYearModel.model),
	settlementFeeTarget: z.number().nullable(),
	settlementFeeActual: z.number().nullable(),
	settlementFeeResultRate: z.number().nullable(),
	totalSalesRadio: z.number().nullable()
});

const model = schema.transform((values) => ({
	...values
}));

export const SettlementModel = {schema, model};
export type ISettlementModel = z.infer<typeof SettlementModel.model>;
export const DEFAULT_SETTLEMENT: ISettlementModel = {
	department: "",
	managerInformation: null,
	halfYears: [],
	settlementFeeTarget: 0,
	settlementFeeActual: 0,
	settlementFeeResultRate: 0,
	totalSalesRadio: 0
};
